<template>
  <a-form-model :form="filterForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :model="filterForm" class="search-form">
    <a-row :gutter="16">
      <a-col :span="6">
        <a-form-model-item label="名称/ID">
          <a-input v-model="filterForm.name" placeholder="任务名称/ID" style="width: 100%" class="form-model-item" allow-clear @change="handleNameChange" />
        </a-form-model-item>
      </a-col>
      <a-col :span="6">
        <a-form-model-item label="状态">
          <a-select v-model="filterForm.status" mode="multiple" style="width: 100%" placeholder="任务状态" allow-clear @change="handleChange">
            <a-select-option v-for="(item, index) in taskStatus" :key="index" :value="item.value">
              <a-badge :status="item.status" :color="item.color" :text="item.label" />
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
      <a-col :span="5">
        <a-form-model-item label="处理人">
          <user-select v-model="filterForm.handlers" :project-id="projectId" style="width: 100%" mode="multiple" allow-clear show-search show-all placeholder="任务处理人" @change="handleChange" />
        </a-form-model-item>
      </a-col>
      <a-col :span="7">
        <span style="line-height: 40px">
          <a-popover placement="bottomLeft" trigger="click">
            <template slot="title">
              <div>
                更多筛选
                <a-divider type="vertical" />
                <a-button v-tc="{ name: '重置更多筛选' }" class="handle-menu" type="link" @click="onReset">重置</a-button>
              </div>
            </template>
            <template slot="content">
              <div style="width: 800px; margin-bottom: 10px; padding: 0 5px">
                <a-form-model style="width: 100%" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :model="filterForm">
                  <a-row :gutter="16">
                    <a-col v-if="['task'].includes(type)" :span="12">
                      <a-form-model-item label="关联迭代">
                        <a-select v-model="filterForm.version_id" placeholder="任务关联迭代" allow-clear @focus="getVersionData" @change="handleChange">
                          <a-select-option v-for="version in versionData" :key="version.id" :value="version.id"> {{ version.title }} </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col v-if="['work'].includes(type)" :span="12">
                      <a-form-model-item label="所属项目">
                        <a-select v-model="filterForm.projectList" mode="multiple" show-search placeholder="任务所属项目" allow-clear @focus="getProjectData" @change="handleChange">
                          <a-select-option v-for="version in projectData" :key="version.project_id" :value="version.project_id"> {{ version.name }} </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="关联需求">
                        <a-select v-model="requirementValue" mode="multiple" placeholder="关联需求" show-search allow-clear label-in-value :filter-option="false" :not-found-content="storySearching ? undefined : null" @search="searchStory" @change="handleStoryChange">
                          <a-spin v-if="storySearching" slot="notFoundContent" size="small" />
                          <a-select-option v-for="item in searchStoryData" :key="item.value" :value="item.value" :version="item.version">
                            {{ item.label }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="创建人">
                        <user-select v-model="filterForm.creator" :project-id="projectId" allow-clear show-search show-all placeholder="任务创建人" @change="handleChange" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="标签">
                        <a-select v-model="filterForm.tagData" mode="multiple" show-search placeholder="标签" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                          <a-select-option v-for="(tag, index) in tagData" :key="index" :value="tag.id">{{ tag.name }} </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="任务类型">
                        <a-tree-select v-model="filterForm.objective" show-search placeholder="任务类型" tree-default-expand-all multiple :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" style="width: 100%" :tree-data="objectiveData" @change="handleChange" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="与我相关">
                        <a-radio-group v-model="filterForm.about" button-style="solid" @change="handleChange">
                          <a-radio-button value="all"> 全部 </a-radio-button>
                          <a-radio-button value="about"> 与我相关 </a-radio-button>
                        </a-radio-group>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="24">
                      <a-form-model-item label="时间筛选" :label-col="{ span: 3 }">
                        <a-input-group compact>
                          <a-select v-model="filterForm.time_filter_key" style="width: 30%" @change="handleChange">
                            <a-select-option value="pre_time"> 计划时间 </a-select-option>
                            <a-select-option value="real_time"> 实际时间 </a-select-option>
                            <a-select-option value="created_time"> 创建时间 </a-select-option>
                            <a-select-option value="completed_time"> 完成时间 </a-select-option>
                          </a-select>
                          <a-date-picker v-model="filterForm.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleChange" />
                          <a-date-picker v-model="filterForm.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleChange" />
                        </a-input-group>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form-model>
              </div>
            </template>
            <span>
              <a-badge
                :number-style="{
                  backgroundColor: '#448EF7',
                  cursor: 'pointer'
                }"
                :count="filterCount"
              >
                <a-button v-tc="{ name: '更多筛选' }" icon="filter">更多筛选</a-button>
              </a-badge>
            </span>
          </a-popover>
          <a-button v-tc="{ name: '查询' }" type="primary" :loading="loading" style="margin: 0 8px" @click="handleChange">
            {{ loading ? '查询中' : '查询' }}
          </a-button>
          <a-button v-tc="{ name: '重置' }" @click="onReset">重置</a-button>
        </span>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { debounce } from 'lodash';
import { tagList } from '@/api/system/tag';
import { storySearch } from '@/api/project/story';
import { versionList } from '@/api/project/version';
import { projectList } from '@/api/project/project';
import { taskStatus, taskPrioritys } from '@/utils/dictionary';

import UserSelect from '@/components/User/UserSelect';

export default {
  components: { UserSelect },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: 'task' // work 、version
    }
  },
  data() {
    return {
      loading: false,
      requirementValue: [],
      taskStatus,
      taskPrioritys,
      filterForm: {},
      versionData: [],
      projectData: [],
      projectId: parseInt(this.$route.params.project_id) || 0,
      searchStoryData: [],
      tagData: [],
      storySearching: false,
      objectiveData: [
        { key: 1, value: 1, disabled: true, title: '编码任务', children: [] },
        { key: 2, disabled: true, value: 2, title: '非编码任务', children: [] }
      ]
    };
  },
  computed: {
    filterCount() {
      var count = 0;
      if (!this.filterForm) return count;
      const _data = this.filterForm;
      const keys = Object.keys(_data);

      for (const key of keys) {
        if (['page_size', 'page_number', 'name', 'status', 'handlers', 'time_filter_key', 'project_id', 'fields'].includes(key)) continue;
        const v = _data[key];
        if (!v || (Array.isArray(v) && v.length === 0)) continue;

        if (key === 'about' && v === 'all') {
          continue;
        }

        if (key === 'searchTimeType') {
          continue;
        }
        // console.log(key, v);
        count++;
      }

      return count;
    }
  },
  watch: {
    value: {
      handler(val) {
        this.filterForm = val || {};
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getTagList();
    this.getObjectiveList();
  },
  methods: {
    handleChange() {
      this.$emit('update:value', this.filterForm);
      this.$emit('change', this.filterForm);
    },

    handleNameChange: debounce(function () {
      this.handleChange();
    }, 500),

    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    handleStoryChange(value) {
      if (value) {
        this.filterForm.requirement_ids = value.map(item => item.key);
      } else {
        this.filterForm.requirement_id = [];
      }
      this.handleChange();
    },
    onReset() {
      this.requirementValue = [];
      this.$emit('reset');
    },
    // 需求搜索
    searchStory: debounce(function (value = null) {
      const filter = { value: value };
      if (this.projectId > 0) {
        filter.project_id = this.projectId;
      }
      storySearch(filter).then(res => {
        this.searchStoryData = res.data.items;
      });
    }, 500),

    getProjectData() {
      projectList({ page_index: 1, page_size: 100 }).then(res => {
        this.projectData = res.data.projects;
      });
    },

    getVersionData() {
      versionList({ project_id: this.projectId, page_index: 1, page_size: 100 }).then(res => {
        this.versionData = res.data.list;
      });
    },

    getTagList() {
      tagList({ group_code: 'task_req_tag' }).then(res => {
        this.tagData = res.data.items;
      });
    },
    getObjectiveList() {
      tagList({ group_code: 'coding_task' }).then(res => {
        const children = res.data.items.map(item => ({
          key: item.id,
          value: item.id,
          title: item.name
        }));
        this.objectiveData[0].children = children;
      });
      tagList({ group_code: 'un_coding_task' }).then(res => {
        const children = res.data.items.map(item => ({
          key: item.id,
          value: item.id,
          title: item.name
        }));
        this.objectiveData[1].children = children;
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 2px;
}
/deep/.ant-form {
  margin: 4px 0px !important;
}

.form-model-item {
  width: 100%;
}
.filter-btn {
  margin-top: 18px;
}
</style>
